import React from 'react';

export interface CardProps {
    children: React.ReactNode;
    className?: string;
}

export interface CardHeaderProps {
    children: React.ReactNode;
    className?: string;
}

export interface CardBodyProps {
    children: React.ReactNode;
    className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = '' }) => {
    return (
        <div className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden ${className}`}>
            {children}
        </div>
    );
};

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className = '' }) => {
    return (
        <div className={`px-3 sm:px-6 py-3 sm:py-4 border-b border-gray-200 bg-gray-50 ${className}`}>
            {children}
        </div>
    );
};

export const CardBody: React.FC<CardBodyProps> = ({ children, className = '' }) => {
    return (
        <div className={`p-3 sm:p-6 ${className}`}>
            {children}
        </div>
    );
};

export default Card;
